import React, { useState } from "react";
import { Link } from "react-router-dom";
import phrasebookLoad from "../../../i18n";
import { trueOrFalse, required, ifZero, noMaximum, capitalizeFirstLetter } from "../../../helpers/util"
import { DisplayInfo } from "../../../components/SkyFramework/Boxes/DisplayInfo";
import { loggedAccountType } from "../../../helpers/token";
import { CancelButton } from "../../../components/SkyFramework/Buttons"
import { Modal, ModalButton } from '../../../components/SkyFramework/Modal'

import { gisRoutes } from "../../../routes/routes";

// Constants
const phrasebook = phrasebookLoad();
const requirements = [['end_user_name_req', 'end_user_name'], ['end_user_contact_req', 'end_user_contact_phone'], ['end_user_contact_req', 'end_user_contact_email'], ['end_user_address_req', 'end_user_address'],
['end_user_address_proof_req', 'end_user_address_proof'], ['purpose_application_req', 'purpose_application'], ['declaration_letter_req', 'declaration_letter'], ['usage_forecast_req', 'usage_forecast'], ['business_nature_req', 'business_nature'], ['business_registration_req', 'business_registration_jurisdiction'], ['business_registration_req', 'business_registration_number'], ['business_registration_doc_req', 'business_registration_doc'], ['itu_assignment_notification_req', 'itu_assignment_doc'], ['authorised_person_passport_id_req', 'authorised_person_passport_id'], ['authpers_passportholding_req', 'authorised_person_passport_holding_photo_id']];
const customer_requirements = [['purpose_application_req', 'purpose_application'], ['declaration_letter_req', 'declaration_letter'], ['usage_forecast_req', 'usage_forecast']];
const business_requirements = [['business_nature_req', 'business_nature'], ['business_registration_req', 'business_registration_jurisdiction'], ['business_registration_req', 'business_registration_number'], ['business_registration_doc_req', 'business_registration_doc'], ['itu_assignment_notification_req', 'itu_assignment_doc']];

const end_user_requirements = [['end_user_name_req', 'end_user_name'], ['end_user_contact_req', 'end_user_contact_phone'], ['end_user_contact_req', 'end_user_contact_email'], ['end_user_address_req', 'end_user_address'],
['end_user_address_proof_req', 'end_user_address_proof'], ['authorised_person_passport_id_req', 'authorised_person_passport_id'], ['authpers_passportholding_req', 'authorised_person_passport_holding_photo_id']];
const portability_requirements = [['prt_consentletter_req', 'portability_end_user_consent_letter'], ['prt_hstcarriers_req', 'portability_name_existing_hosting_carriers'], ['portability_forms', 'portability_forms'], ['portability_latest_invoices_req', 'portability_latest_invoices']]

export const initialState = (customer_id, order_id) => {

  return {
    step: 1,

    //step 1 states
    service_types: [{ value: 'ITFS', label: 'ITFS' }, { value: 'UIFN', label: 'UIFN' }, { value: 'DID', label: 'DID' }, { value: 'SIP Trunking', label: 'SIP Trunking' }],
    customers: undefined,
    customer: undefined,
    jurisdiction_coverage: undefined,
    dialcodes: [],
    cities: undefined,
    service_type: undefined,
    jurisdiction: undefined,
    created_by: undefined,

    //step2 states
    limit: 10,
    page: 0,
    numberSearched: false,
    selectedTypeNumber: undefined,

    //step3 Formated numbers if required

    //order values to save
    id: order_id,
    customer_id: customer_id,
    service_number_type_order_history_id: undefined,
    service_number_type_id: undefined,
    city: undefined,
    city_specific: undefined,
    porting: undefined,
    porting_number_to: undefined,
    porting_number_to_file: undefined,
    number_quantity: undefined,
    channel_quantity: undefined,
    translation_number_required: true,
    translation_number_type: undefined,
    translation_number_format: 'e.164',
    translation_number_prefix: undefined,
    translation_number_to: undefined,
    translation_number_to_file: undefined,
    reference: undefined,
    end_user_name: undefined,
    end_user_address: undefined,
    end_user_address_proof: undefined,
    end_user_contact_phone: undefined,
    end_user_contact_email: undefined,
    business_nature: undefined,
    purpose_application: undefined,
    usage_forecast: undefined,
    business_registration_jurisdiction: undefined,
    business_registration_number: undefined,
    business_registration_doc: undefined,
    itu_assignment_doc: undefined,
    declaration_letter: undefined,
    authorised_person_passport_id: undefined,
    authorised_person_passport_holding_photo_id: undefined,
    portability_end_user_consent_letter: undefined,
    portability_name_existing_hosting_carriers: undefined,
    portability_forms: undefined,
    portability_latest_invoices: undefined,
    additional_remarks: undefined,
    pccwglobal_remarks: undefined,
    date_purchase: undefined,
    status: undefined,
    terms_and_conditions: undefined,
    add_custom: false,
    custom_tariff: undefined,
    order: undefined,
  };
}

export const submitValues = (actualState) => {
  return {
    customer_id: actualState.customer_id,
    service_number_type_order_history_id: actualState.service_number_type_order_history_id,
    service_number_type_id: actualState.service_number_type_id,
    city: actualState.city_specific ? actualState.city_specific : actualState.city,
    porting: actualState.porting,
    porting_number_to: actualState.porting_number_to,
    porting_number_to_file: actualState.porting_number_to_file,
    number_quantity: actualState.number_quantity ? actualState.number_quantity : 0,
    channel_quantity: actualState.channel_quantity ? actualState.channel_quantity : 0,
    translation_number_required: actualState.translation_number_required,
    translation_number_type: actualState.translation_number_type,
    translation_number_format: actualState.translation_number_format,
    translation_number_prefix: actualState.translation_number_prefix,
    translation_number_to: actualState.translation_number_to,
    translation_number_to_file: actualState.translation_number_to_file,
    reference: actualState.reference,
    end_user_name: actualState.end_user_name,
    end_user_address: actualState.end_user_address,
    end_user_address_proof: actualState.end_user_address_proof,
    end_user_contact_phone: actualState.end_user_contact_phone,
    end_user_contact_email: actualState.end_user_contact_email,
    purpose_application: actualState.purpose_application,
    usage_forecast: actualState.usage_forecast,
    business_nature: actualState.business_nature,
    business_registration_jurisdiction: actualState.business_registration_jurisdiction,
    business_registration_number: actualState.business_registration_number,
    business_registration_doc: actualState.business_registration_doc,
    itu_assignment_doc: actualState.itu_assignment_doc,
    declaration_letter: actualState.declaration_letter,
    authorised_person_passport_id: actualState.authorised_person_passport_id,
    authorised_person_passport_holding_photo_id: actualState.authorised_person_passport_holding_photo_id,
    portability_end_user_consent_letter: actualState.portability_end_user_consent_letter,
    portability_name_existing_hosting_carriers: actualState.portability_name_existing_hosting_carriers,
    portability_forms: actualState.portability_forms,
    portability_latest_invoices: actualState.portability_latest_invoices,
    additional_remarks: actualState.additional_remarks,
    pccwglobal_remarks: actualState.pccwglobal_remarks,
    status: actualState.status,
    custom_tariff: actualState.custom_tariff
  }
}

export const updateState = (order) => {
  order.servicenumbertypeorderhistory.tariff = order.servicenumbertypeorderhistory
  return {
    selectedTypeNumber: order.servicenumbertypeorderhistory,
    customer_id: order.customer_id,
    created_by: order.created_by,
    service_number_type_order_history_id: order.service_number_type_order_history_id,
    service_number_type_id: order.service_number_type_id,
    city: order.city,
    porting: order.porting,
    porting_number_to: order.porting_number_to,
    porting_number_to_file: order.porting_number_to_file,
    number_quantity: order.number_quantity,
    channel_quantity: order.channel_quantity,
    translation_number_required: order.translation_number_required,
    translation_number_type: order.translation_number_type,
    translation_number_format: order.translation_number_format,
    translation_number_prefix: order.translation_number_prefix,
    translation_number_to: order.translation_number_to,
    translation_number_to_file: order.translation_number_to_file,
    reference: order.reference,
    end_user_name: order.end_user_name,
    end_user_address: order.end_user_address,
    end_user_address_proof: order.end_user_address_proof,
    end_user_contact_phone: order.end_user_contact_phone,
    end_user_contact_email: order.end_user_contact_email,

    purpose_application: order.purpose_application,
    usage_forecast: order.usage_forecast,
    business_nature: order.business_nature,
    business_registration_jurisdiction: order.business_registration_jurisdiction,
    business_registration_number: order.business_registration_number,
    business_registration_doc: order.business_registration_doc,
    itu_assignment_doc: order.itu_assignment_doc,
    declaration_letter: order.declaration_letter,
    authorised_person_passport_id: order.authorised_person_passport_id,
    authorised_person_passport_holding_photo_id: order.authorised_person_passport_holding_photo_id,
    portability_end_user_consent_letter: order.portability_end_user_consent_letter,
    portability_name_existing_hosting_carriers: order.portability_name_existing_hosting_carriers,
    portability_forms: order.portability_forms,
    portability_latest_invoices: order.portability_latest_invoices,
    additional_remarks: order.additional_remarks,
    pccwglobal_remarks: order.pccwglobal_remarks,
    date_purchase: order.date_purchase,
    status: order.status,
    order: order
  }
}


export const summaryOrderDetails = (phrasebook, actualState) => {
  function ifCondition(label, value) {
    if (value) return (<><span class="ml-1">
      {label} <strong>{value}</strong>
    </span></>)
  }
  return (
    <>
      {actualState.date_purchase ? <div class="d-flex mb-1">
        <span>
          {phrasebook.orders.date_ordered}: <strong>{actualState.date_purchase}</strong>
        </span>
        <span class="ml-1">
          {phrasebook.orders.order_id}: <strong>{actualState.id}</strong>
        </span>
      </div> : null}
      {actualState.created_by ? <div class="d-flex mb-1">
        <span>
          {phrasebook.filters.created_by}: <strong>{actualState.created_by ? actualState.created_by.userprofile.firstname ? `${actualState.created_by.userprofile.firstname} ${actualState.created_by.userprofile.lastname}` : actualState.created_by.email : `Account deleted`}</strong>
        </span>
      </div> : null}
      <div class="d-flex mb-1">
        <span>
          {phrasebook.numbers.service_type}: <strong>{actualState.selectedTypeNumber.service_type}</strong>
        </span>
        <span class="ml-1">
          {phrasebook.common.option}: <strong>{actualState.selectedTypeNumber.vendor_option}</strong>
        </span>
      </div>
      <div class="d-flex mb-1">
        <span>
          {phrasebook.profile.jurisdiction}: <strong>{actualState.selectedTypeNumber.jurisdiction}</strong>
        </span>
        <span class="ml-1">
          {phrasebook.profile.jurisdiction_dial_code}: <strong>{actualState.selectedTypeNumber.jurisdiction_dial_code}</strong>
        </span>
        {actualState.city_specific ? ifCondition(phrasebook.references.city, actualState.city_specific) : ifCondition(phrasebook.references.city, actualState.city)}
      </div>
      {actualState.additional_remarks ? <div class="d-flex mb-1">
        <p>
          <span>
            {phrasebook.orders.customer_additional_remarks}: <strong>{actualState.additional_remarks}</strong>
          </span>
        </p>
      </div> : null}
      <div class="d-flex mb-1">
        <span>
          {phrasebook.orders.number_quantity}: <strong>{actualState.number_quantity}</strong>
        </span>
        {ifCondition(phrasebook.orders.channel_quantity, actualState.channel_quantity)}
      </div>
      <div class="d-flex mb-1">
        <span>
          {phrasebook.orders.translation_number_format}: <strong>{actualState.translation_number_format}</strong>
        </span>
        {ifCondition(phrasebook.orders.translation_number_prefix, actualState.translation_number_prefix)}
        {ifCondition(phrasebook.orders.porting_required, required(actualState.porting))}
      </div>
      <div class="d-flex mb-1">
        <span >
          {`${phrasebook.common.customer} ${phrasebook.references.reference}`}: <strong>{actualState.reference}</strong>
        </span>
      </div>
    </>
  );
}

export const requirementsNeeded = (actualState, serviceNumberType) => {
  var requirementsNeeded = false;
  requirements.map(requirement => {
    if (serviceNumberType[requirement[0]]) {
      requirementsNeeded = true;
    }
  });
  if (serviceNumberType.portability && actualState.porting) {
    portability_requirements.map(requirement => {
      if (serviceNumberType[requirement[0]]) {
        requirementsNeeded = true;
      }
    });
  }
  return requirementsNeeded;
}

export const requirementsStatus = (actualState) => {
  var requirementsFilled = true;
  requirements.map(requirement => {
    if (actualState.selectedTypeNumber[requirement[0]] && !actualState[requirement[1]]) {
      requirementsFilled = false;
    }
  });

  if (actualState.translation_number_required && ['numberrange', 'individual'].includes(actualState.translation_number_format) && (!actualState.translation_number_to && !actualState.translation_number_to_file)) requirementsFilled = false;
  if (actualState.selectedTypeNumber.portability && actualState.porting) {
    portability_requirements.map(requirement => {
      if (actualState.selectedTypeNumber[requirement[0]] && !actualState[requirement[1]]) {
        requirementsFilled = false;
      }
    });
    if (!actualState.porting_number_to && !actualState.porting_number_to_file) requirementsFilled = false;
  }

  return requirementsFilled;
}

export const orderStatus = (actualState) => {
  return <div class="alert alert-info">
    <p>The actual status of this order is "{actualState.status}"</p>
  </div>
}

export const summaryStatus = (actualState, loggedAccount, handleChange) => {

  if (actualState.status === 'accepted') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_accepted}</p>
    </div>
  } if (actualState.status === 'processed') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_processed}</p>
    </div>
  } else if (actualState.status === 'assigned') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_assigned}</p>
    </div>
  } else if (actualState.status === 'ordered') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_ordered}</p>
    </div>
  } else if (actualState.status === 'testing') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_testing}</p>
    </div>
  } else if (actualState.status === 'cancellation') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_is_canceling}</p>
    </div>
  } else if (actualState.status === 'completed') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_completed}</p>
    </div>;
  } else if (actualState.status === 'cancelled') {
    return <div class="alert alert-info">
      <p>{phrasebook.orders.order_cancelled}</p>
    </div>;
  } else if (loggedAccount < 200) {
    if (['ready'].includes(actualState.status)) {
      return <div class="row row-sm">
        <label ><strong>{phrasebook.orders.pccwglobal_remarks}</strong><i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={phrasebook.tooltip.pccwglobal_remarks}></i></label>
        <textarea type="text" id="pccwglobal_remarks" name="pccwglobal_remarks" onChange={handleChange} value={actualState.pccwglobal_remarks} />
      </div>
    } else return null;
  }
  else if (loggedAccount >= 200) {
    var pccw_remarks = (remarks) => {
      if (remarks) return <div class="alert alert-warning">
        <label className="d-label">
          <strong>{phrasebook.orders.pccwglobal_remarks}</strong>
        </label>
        <span className="pl-h">
          {actualState.pccwglobal_remarks}
        </span>
      </div>

      else return null
    }
    var requirements = () => {
      if (requirementsStatus(actualState)) {
        return <div class="alert alert-info">
          <p>{phrasebook.orders.pccw_check_order}</p>
        </div>
      } else return null;
    }
    if (actualState.status == 'incomplete') {
      if (actualState.pccwglobal_remarks) {
        return pccw_remarks(actualState.pccwglobal_remarks);
      } else {
        return <div class="alert alert-warning"><p>Something went wrong with your order, please communicate with your Account Manager</p></div>
      }
    }
    else if (['requested', 'saved'].includes(actualState.status)) {
      if (actualState.pccwglobal_remarks) {
        return pccw_remarks(actualState.pccwglobal_remarks);
      } else {
        return requirements();
      }
    }
    else if (['ready'].includes(actualState.status)) {
      return <>
        <div class="alert alert-info"><p>{phrasebook.orders.ready_order}</p></div>
        <div class="alert alert-warning"><p>{phrasebook.orders.calcelation_warning}</p></div>
      </>
    } else return <><div class="alert alert-warning">
      <p>{phrasebook.orders.calcelation_warning}</p>
    </div></>
  } else return null;
  //remarks or banner
}


export const summaryButtons = (actualState, loggedAccount, handleSubmit, prevStep, saveChanges) => {
  function basicButton(buttonviews, status, handleSubmit, modalMessage, modalTitle, modalid) {
    return <><div class="box-actions-footer mt-4">
      {buttonviews.map(button => button)}
    </div>
      <Modal
        title={modalTitle ? modalTitle : phrasebook.orders.update_order}
        description={modalMessage ? modalMessage : phrasebook.orders.update_sure + status}
        cancelLabel={phrasebook.common.cancel}
        confirmLabel={phrasebook.common.confirm}
        onClick={handleSubmit}
        id={status}
        modalid={modalid}
      />
    </>
  }
  if (loggedAccount < 200) {
    if (actualState.status == 'ready') {
      return <>
        {basicButton([<ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_incomplete} />, <button className="btn btn-faded" onClick={prevStep}>{phrasebook.common.previous} </button>, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_accepted} href={'#modalidaccept'} />], "incomplete", handleSubmit, phrasebook.orders.incomplete_pre_sure, phrasebook.orders.incomplete_order)}
        {basicButton([], "accepted", handleSubmit, phrasebook.orders.accept_pre_sure, phrasebook.orders.accept_order, "modalidaccept")}
      </>




      return <><div class="box-actions-footer mt-4">
        <button className="btn btn-faded" onClick={prevStep}>{phrasebook.common.previous} </button>
        <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_incomplete} href={'modalidincomplete'} />
        <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_accepted} href={'modalidaccept'} />
      </div>
        <Modal
          title={phrasebook.orders.update_order}
          description={phrasebook.orders.update_sure + 'accepted'}
          cancelLabel={phrasebook.common.cancel}
          confirmLabel={phrasebook.common.confirm}
          onClick={handleSubmit}
          id={'accepted'}
          modalid={'modalidaccept'}
        />
        <Modal
          title={phrasebook.orders.update_order}
          description={phrasebook.orders.update_sure + 'incomplete'}
          cancelLabel={phrasebook.common.cancel}
          confirmLabel={phrasebook.common.confirm}
          onClick={handleSubmit}
          id={'incomplete'}
          modalid={'modalidincomplete'}
        />
      </>
    }
    if (['requested', 'saved', 'confirmed'].includes(actualState.status)) {
      if (actualState.add_custom) {
        return basicButton([<button className="btn btn-faded" onClick={prevStep}>
          {phrasebook.common.previous}
        </button>, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.process_order} />], "processed", handleSubmit, phrasebook.orders.process_pre_sure, phrasebook.orders.process_order);
      } else return basicButton([<button className="btn btn-faded" onClick={prevStep}>
        {phrasebook.common.previous}
      </button>]);
    } else {
      switch (actualState.status) {
        case 'accepted':
          return basicButton([<CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_assigned} />], "assigned", handleSubmit)
        case 'assigned':
          return basicButton([<CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_ordered} />], "ordered", handleSubmit)
        case 'ordered':
          return basicButton([<CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_testing} />], "testing", handleSubmit)
        case 'testing':
          return basicButton([<CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_completed} />], "completed", handleSubmit)
        case 'completed':
          return basicButton([<CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />,])
        case 'cancellation':
          return basicButton([<CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.move_to_cancelled} />], "cancelled", handleSubmit)
        case 'cancelled':
          return basicButton([<CancelButton
            link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />,])
      }
    }
  } else {
    if (['processed'].includes(actualState.status)) {
      return <>
        {basicButton([<ModalButton className={'btn btn-sec'} label={phrasebook.orders.cancel_order} />, <CancelButton
          link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />, <ModalButton className={'btn btn-sec'} label={phrasebook.orders.confirm_order} href={"#modconfirm"} />], "cancellation", handleSubmit, phrasebook.orders.cancel_pre_sure, phrasebook.orders.cancel_order)}
        {basicButton([], "confirmed", handleSubmit, phrasebook.orders.confirmation_order, phrasebook.orders.confirm_order, "modconfirm")}
      </>
    }
    if (['requested', 'saved', 'confirmed', 'incomplete'].includes(actualState.status)) {
      if (requirementsStatus(actualState)) {
        return <>
          {basicButton([<ModalButton className={'btn btn-sec'} label={phrasebook.orders.cancel_order} />, <button className="btn btn-faded" onClick={prevStep}>
            {phrasebook.common.previous}
          </button>, <ModalButton className={'btn btn-sec'} label={`${phrasebook.common.submit} ${phrasebook.headerlinks.order}`} href={"#modready"} />], "cancellation", handleSubmit, phrasebook.orders.cancel_pre_sure, phrasebook.orders.cancel_order)}
          {basicButton([], "ready", handleSubmit, phrasebook.orders.ready_order_submit, phrasebook.orders.submit_order, "modready")}
        </>
      } else {
        return basicButton([<ModalButton className={'btn btn-sec'} label={phrasebook.orders.cancel_order} />, <button className="btn btn-faded" onClick={prevStep}>
          {phrasebook.common.previous}
        </button>])
      }

    } else if (['ready', 'accepted', 'assigned', 'ordered', 'testing'].includes(actualState.status)) {
      return basicButton([<ModalButton className={'btn btn-sec'} label={phrasebook.orders.cancel_order} />, <CancelButton
        link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />], "cancellation", handleSubmit, phrasebook.orders.cancel_post_sure, phrasebook.orders.cancel_order)
    }
    else {
      return basicButton([<CancelButton
        link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} />])
    }
  }

}

export const summaryRequirements = (phrasebook, actualState) => {
  function ifExist(requirement) {
    return requirement ? requirement : 'Pending'
  }

  function alertMessage(title, count, view) {
    if (count === 0) {
      return <>      <h4 class="mb-2">{title}</h4>
        <div class="alert alert-info">
          <p>{phrasebook.alerts.requirements_provided}</p>
        </div>
        {view.map(row => row)}</>
    }
    else {
      return <><h4 class="mb-2">{title}</h4><div class="alert alert-warning">
        <p>{phrasebook.alerts.requirements_needed}</p>
      </div>
        {view.map(row => row)}</>
    }
  }

  function pushReq(requirements, actualState, title) {
    var view = []
    var reqcount = 0
    var req1;
    requirements.map(requirement => {
      if (actualState.selectedTypeNumber[requirement[0]]) {
        req1 = requirement[0];
        if (requirement[0] == 'end_user_contact_req') {
          if (requirement[1] == 'end_user_contact_phone') req1 = 'end_user_contact_phone_req'
          else req1 = 'end_user_contact_email_req'
        }
        if (actualState[requirement[1]]) {
          view.push(<div class="alert alert-info"><p><span>{phrasebook.numbers[req1]}: <strong>{ifExist(actualState[requirement[1]])}</strong></span></p></div>)
        } else {
          view.push(<div class="alert alert-warning"><p><span>{phrasebook.numbers[req1]}: <strong>{ifExist(actualState[requirement[1]])}</strong></span></p></div>)
          reqcount = reqcount + 1;
        }
      }
    })
    return alertMessage(title, reqcount, view);
  }

  function translatReq(actualState) {
    var view = []
    var reqcount = 0
    if (actualState.translation_number_required && ['numberrange', 'individual'].includes(actualState.translation_number_format)) {
      if (actualState.translation_number_to || actualState.translation_number_to_file) {
        view.push(<div class="alert alert-info"><p><span>{phrasebook.orders.translation_number}: <strong> Translations Provided </strong></span></p></div>)
      } else {
        view.push(<div class="alert alert-warning"><p><span>{phrasebook.orders.translation_number}: <strong>Translations Not Provided</strong></span></p></div>)
        reqcount = reqcount + 1;
      }
    }
    return alertMessage(phrasebook.orders.translation_requirements, reqcount, view);

  }

  function portReq(actualState) {
    var view = []
    var reqcount = 0
    if (actualState.selectedTypeNumber.portability && actualState.porting) {
      portability_requirements.map(requirement => {
        if (actualState.selectedTypeNumber[requirement[0]]) {
          if (actualState[requirement[1]]) {
            view.push(<div class="alert alert-info"><p><span>{phrasebook.numbers[requirement[0]]}: <strong>{ifExist(actualState[requirement[1]])}</strong></span></p></div>)
          } else {
            view.push(<div class="alert alert-warning"><p><span>{phrasebook.numbers[requirement[0]]}: <strong>{ifExist(actualState[requirement[1]])}</strong></span></p></div>)
            reqcount = reqcount + 1;
          }
        }
      });
      if (actualState.porting_number_to || actualState.porting_number_to_file) {
        view.push(<div class="alert alert-info"><p><span>{phrasebook.orders.porting_required}: <strong> Porting Numbers Provided </strong></span></p></div>)
      } else {
        view.push(<div class="alert alert-warning"><p><span>{phrasebook.orders.porting_required}: <strong>Porting Numbers Not Provided</strong></span></p></div>)
        reqcount = reqcount + 1;
      }
    }
    return alertMessage(phrasebook.orders.porting_req, reqcount, view);
  }

  function ifRequired(actualState) {
    var view = []


    view.push(pushReq(customer_requirements, actualState, phrasebook.orders.customer_information_req));
    view.push(pushReq(business_requirements, actualState, phrasebook.numbers.business_req));
    view.push(pushReq(end_user_requirements, actualState, phrasebook.numbers.end_user_req));
    view.push(translatReq(actualState));
    view.push(portReq(actualState));

    return <>{view.map(row => row)}</>

  }
  return (
    <div class="section-block">
      <h3 class="mb-2"><strong>{phrasebook.common.requirements}</strong></h3>
      {ifRequired(actualState)}
    </div>
  );
}

export const summaryNumberFeature = (phrasebook, inputs) => {
  return (
    <div class="section-block">
      <h3 class="mb-2">{phrasebook.orders.detail_services}</h3>
      <DisplayInfo inputs={inputs} />
    </div>
  );
}

export const summaryCharges = (actualState) => {
  var final_currency = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.currency ? actualState.custom_tariff.currency : actualState.selectedTypeNumber.tariff.currency;
  const currencies = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'HKD': 'HK$',
    'CNY': '¥',
    'SGD': '$',
  }
  function calculationFixed(quantity, cost) {
    return quantity * cost;
  }
  function currencyPosition(cost, currency) {
    // if (['£', '$'].includes(currency)) return `${currency}${cost}`
    // else
    return `${currency} ${cost}`
  }

  function row(title, quantity, cost, currency, tooltip) {
    return <div class="d-flex justify-content-between border-bottom py-h mb-h">
      <span>{title} {quantity ? `${cost} x ${quantity}` : null}</span>
      <span>{currencyPosition(quantity ? calculationFixed(quantity, cost) : cost, currencies[currency])} </span>
    </div>
  }

  // function rowinfo(title, cost, currency, tooltip) {
  //   return <div class="d-flex justify-content-between border-bottom py-h mb-h">
  //     <span>{title}</span>
  //     <span>{currencyPosition(cost, currencies[currency])} </span>
  //   </div>
  // }

  function nrc_charges(actualState) {
    var rows = [];
    var nrc = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.nrc ? actualState.custom_tariff.nrc : actualState.selectedTypeNumber.tariff.nrc;
    var nrc_channel_charges = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.nrc_channel_charges ? actualState.custom_tariff.nrc_channel_charges : actualState.selectedTypeNumber.tariff.nrc_channel_charges;
    if (actualState.number_quantity || actualState.channel_quantity) {
      if (actualState.number_quantity) {
        rows.push(row(phrasebook.pricing.nrc, actualState.number_quantity, nrc, final_currency, phrasebook.pricing.nrc_tooltip))
      }
      if (actualState.selectedTypeNumber.service_type === 'SIP Trunking' && actualState.channel_quantity) {
        rows.push(row(phrasebook.pricing.nrc_channel_charges, actualState.channel_quantity, nrc_channel_charges, final_currency, phrasebook.pricing.nrc_tooltip))
      }
      return (<div class="section-block">
        <h4>{phrasebook.pricing.nrc_tooltip}</h4>
        {rows}
      </div>
      )
    }
    else return null
  }

  function mrc_charges(actualState) {
    var mrc = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.mrc ? actualState.custom_tariff.mrc : actualState.selectedTypeNumber.tariff.mrc;
    var mrc_channel_charges = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.mrc_channel_charges ? actualState.custom_tariff.mrc_channel_charges : actualState.selectedTypeNumber.tariff.mrc_channel_charges;
    var rows = [];
    if (actualState.number_quantity || actualState.channel_quantity) {
      if (actualState.number_quantity) {
        rows.push(row(phrasebook.pricing.mrc, actualState.number_quantity, mrc, final_currency, phrasebook.pricing.mrc_tooltip))
      }
      if (actualState.selectedTypeNumber.service_type === 'SIP Trunking' && actualState.channel_quantity) {
        rows.push(row(phrasebook.pricing.mrc_channel_charges, actualState.channel_quantity, mrc_channel_charges, final_currency, phrasebook.pricing.mrc_tooltip))
      }
      return (<div class="section-block">
        <h4>{phrasebook.pricing.mrc_tooltip}</h4>
        {rows}

        {/* <div class="alert alert-warning">
          <p>{phrasebook.orders.prior_notice}</p>
        </div> */}
      </div>
      )
    }
    else return null
  }

  function per_usage_charges(actualState) {
    var rows = [];

    var fix_usage_rate = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.fix_usage_rate ? actualState.custom_tariff.fix_usage_rate : actualState.selectedTypeNumber.tariff.fix_usage_rate;

    var mobile_usage_rate = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.mobile_usage_rate ? actualState.custom_tariff.mobile_usage_rate : actualState.selectedTypeNumber.tariff.mobile_usage_rate;

    var payphone_usage_rate = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.payphone_usage_rate ? actualState.custom_tariff.payphone_usage_rate : actualState.selectedTypeNumber.tariff.payphone_usage_rate;

    var outbound_charges_fixed = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.outbound_charges_fixed ? actualState.custom_tariff.outbound_charges_fixed : actualState.selectedTypeNumber.tariff.outbound_charges_fixed;

    var outbound_charges_mobile = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.outbound_charges_mobile ? actualState.custom_tariff.outbound_charges_mobile : actualState.selectedTypeNumber.tariff.outbound_charges_mobile;

    if (actualState.selectedTypeNumber.tariff.fix_usage_rate) rows.push(row(phrasebook.pricing.fix_usage_rate, undefined, fix_usage_rate, final_currency))

    if (actualState.selectedTypeNumber.tariff.mobile_usage_rate) rows.push(row(phrasebook.pricing.mobile_usage_rate, undefined, mobile_usage_rate, final_currency))

    if (actualState.selectedTypeNumber.tariff.payphone_usage_rate) rows.push(row(phrasebook.pricing.payphone_usage_rate, undefined, payphone_usage_rate, final_currency))

    if (((actualState.selectedTypeNumber.service_type === 'DID' && actualState.selectedTypeNumber.outbound_calling_enabled) || actualState.selectedTypeNumber.service_type === 'SIP Trunking') && actualState.selectedTypeNumber.tariff.outbound_charges_fixed) rows.push(row(phrasebook.pricing.outbound_charges_fixed, undefined, outbound_charges_fixed, final_currency))

    if (((actualState.selectedTypeNumber.service_type === 'DID' && actualState.selectedTypeNumber.outbound_calling_enabled) || actualState.selectedTypeNumber.service_type === 'SIP Trunking') && actualState.selectedTypeNumber.tariff.outbound_charges_mobile) rows.push(row(phrasebook.pricing.outbound_charges_mobile, undefined, outbound_charges_mobile, final_currency))

    if (rows.length > 0) {
      return (<div class="section-block mt-3">
        <div class="section-block">
          <h4>{phrasebook.pricing.per_minute_charges}</h4>
          {rows}
        </div>
      </div>)
    } else return null;

  }

  function inbound_charges(actualState) {
    if (['DID', 'SIP Trunking'].includes(actualState.selectedTypeNumber.service_type)) {
      var inbound_charges = actualState.add_custom && actualState.custom_tariff && actualState.custom_tariff.inbound_charges ? actualState.custom_tariff.inbound_charges : actualState.selectedTypeNumber.tariff.inbound_charges;
      return (
        <div class="section-block mt-3">
          <div class="section-block">
            <h4>{phrasebook.pricing.inbound_charges_per_minute}</h4>
            {row(phrasebook.pricing.inbound_charges, undefined, inbound_charges, final_currency)}
          </div></div>)
    } else return null;
  }

  return (
    <div class="section-block">
      <h3 class="mb-2"><strong>{phrasebook.pricing.charges}</strong></h3>
      <div class="section-block mt-3">
        <div class="section-block">
          <div class="d-flex justify-content-between border-bottom py-h mb-h">
            <span>{phrasebook.references.currency}</span>
            <span>{final_currency}</span>
          </div>
        </div>
      </div>
      <div class="section-block">
        {nrc_charges(actualState)}
      </div>

      <div class="section-block mt-3">
        {mrc_charges(actualState)}
      </div>
      {per_usage_charges(actualState)}
      {inbound_charges(actualState)}
    </div >
  );
}

export const customerRequirements = (phrasebook, selectedTypeNumber, actualState, loggedAccount) => {

  const requirements = [
    {
      group: 'general',
      requirements: [{
        condition: 'declaration_letter_req',
        link: {
          id: 'declaration_letter_link',
          name: 'template',
          type: 'download',
          label: phrasebook.numbers.declaration_letter_link
        },
        id: 'declaration_letter',
        name: 'requirement',
        type: loggedAccount >= 200 ? 'file' : 'download',
        label: phrasebook.orders.declaration_letter,
        accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,  image/jpeg, image/png',
        tooltip: phrasebook.tooltip.supported_all,
        value: actualState.declaration_letter
      },
      {
        condition: 'purpose_application_req',
        id: 'purpose_application',
        type: 'text',
        label: phrasebook.orders.purpose_application,
        value: actualState.purpose_application,
        tooltip: phrasebook.tooltip.purpose_application_req
      },
      {
        condition: 'usage_forecast_req',
        id: 'usage_forecast',
        type: 'text',
        label: phrasebook.orders.usage_forecast,
        value: actualState.usage_forecast,
        tooltip: phrasebook.tooltip.usage_forecast_req
      },
      ],
      label: phrasebook.numbers.general_req
    },
    {
      group: 'enduser',
      requirements: [
        {
          condition: 'end_user_name_req',
          id: 'end_user_name',
          type: 'text',
          label: phrasebook.orders.end_user_name,
          value: actualState.end_user_name,
          tooltip: phrasebook.tooltip.end_user_name_req
        },
        {
          condition: 'end_user_contact_req',
          id: 'end_user_contact_phone',
          type: 'text',
          label: phrasebook.orders.end_user_contact_phone,
          value: actualState.end_user_contact_phone
        },
        {
          condition: 'end_user_contact_req',
          id: 'end_user_contact_email',
          type: 'text',
          label: phrasebook.orders.end_user_contact_email,
          value: actualState.end_user_contact_email
        },
        {
          condition: 'end_user_address_req',
          id: 'end_user_address',
          type: 'text',
          label: `${capitalizeFirstLetter(selectedTypeNumber.end_user_address_type)} ${phrasebook.orders.end_user_address}`,
          value: actualState.end_user_address
        },
        {
          condition: 'end_user_address_proof_req',
          id: 'end_user_address_proof',
          name: 'requirement',
          possibilities: 'end_user_address_proof_required',
          type: loggedAccount >= 200 ? 'file' : 'download',
          label: `${capitalizeFirstLetter(selectedTypeNumber.end_user_address_type)}: ${phrasebook.orders.end_user_address_proof}`,
          tooltip: phrasebook.tooltip.supported_all,
          accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,  image/jpeg, image/png',
          value: actualState.end_user_address_proof
        },
        {
          condition: 'authpers_passportholding_req',
          id: 'authorised_person_passport_holding_photo_id',
          name: 'requirement',
          type: loggedAccount >= 200 ? 'file' : 'download',
          label: phrasebook.orders.authorised_person_passport_holding_photo_id,
          accept: 'application/pdf, image/jpeg, image/png',
          value: actualState.authorised_person_passport_holding_photo_id,
          tooltip: phrasebook.tooltip.pdf_jpeg_png,
          tooltip: phrasebook.tooltip.end_user_name_req
        },
        {
          condition: 'authorised_person_passport_id_req',
          id: 'authorised_person_passport_id',
          name: 'requirement',
          type: loggedAccount >= 200 ? 'file' : 'download',
          label: phrasebook.orders.authorised_person_passport_id,
          accept: 'application/pdf, image/jpeg, image/png',
          tooltip: phrasebook.tooltip.pdf_jpeg_png,
          value: actualState.authorised_person_passport_id
        },



      ],
      label: phrasebook.numbers.end_user_req,
    },
    {
      group: 'business',
      requirements: [
        {
          condition: 'business_nature_req',
          id: 'business_nature',
          type: 'text',
          label: phrasebook.orders.business_nature,
          value: actualState.business_nature
        },
        {
          condition: 'business_registration_req',
          id: 'business_registration_number',
          type: 'text',
          label: phrasebook.orders.business_registration_number,
          value: actualState.business_registration_number
        },
        {
          condition: 'business_registration_req',
          id: 'business_registration_jurisdiction',
          type: 'text',
          label: phrasebook.orders.business_registration_jurisdiction,
          value: actualState.business_registration_jurisdiction
        },

        {
          condition: 'business_registration_doc_req',
          id: 'business_registration_doc',
          name: 'requirement',
          possibilities: 'buss_reg_doctypes_req',
          type: loggedAccount >= 200 ? 'file' : 'download',
          label: phrasebook.orders.business_registration_doc,
          tooltip: phrasebook.tooltip.supported_all,
          accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png',
          value: actualState.business_registration_doc
        },
        {
          condition: 'itu_assignment_notification_req',
          id: 'itu_assignment_doc',
          name: 'requirement',
          // possibilities: 'buss_reg_doctypes_req',
          type: loggedAccount >= 200 ? 'file' : 'download',
          label: phrasebook.orders.itu_assignment_doc,
          tooltip: phrasebook.tooltip.supported_all,
          accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png',
          value: actualState.itu_assignment_doc
        },
      ],
      label: phrasebook.numbers.business_req
    },
  ]

  if (selectedTypeNumber.portability && actualState.porting) requirements.push({
    group: 'porting',
    requirements: [
      {
        condition: 'prt_consentletter_req',
        link: {
          id: 'prt_consentletter_link',
          name: 'template',
          type: 'download',
          label: phrasebook.numbers.prt_consentletter_link
        },
        id: 'portability_end_user_consent_letter',
        name: 'requirement',
        type: loggedAccount >= 200 ? 'file' : 'download',
        label: phrasebook.orders.portability_end_user_consent_letter,
        tooltip: phrasebook.tooltip.supported_all,
        accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,  image/jpeg, image/png',
        value: actualState.portability_end_user_consent_letter
      },
      {
        condition: 'prt_hstcarriers_req',
        id: 'portability_name_existing_hosting_carriers',
        type: 'text',
        label: phrasebook.orders.portability_name_existing_hosting_carriers,
        value: actualState.portability_name_existing_hosting_carriers
      },
      {
        condition: 'portability_forms',
        link: {
          id: 'portability_forms_link',
          name: 'template',
          type: 'download',
          label: phrasebook.numbers.portability_forms_link
        },
        id: 'portability_forms',
        name: 'requirement',
        type: loggedAccount >= 200 ? 'file' : 'download',
        label: phrasebook.orders.portability_forms,
        tooltip: phrasebook.tooltip.supported_all,
        accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,  image/jpeg, image/png',
        value: actualState.portability_forms
      },
      {
        condition: 'portability_latest_invoices_req',
        id: 'portability_latest_invoices',
        name: 'requirement',
        type: loggedAccount >= 200 ? 'file' : 'download',
        label: phrasebook.orders.portability_latest_invoices,
        tooltip: phrasebook.tooltip.supported_all,
        accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png',
        value: actualState.portability_latest_invoices
      },
    ],
    label: phrasebook.orders.porting_req,
  })

  let inputs = [
    { label: phrasebook.orders.customer_information_req, type: "section", tooltip: phrasebook.tooltip.requirements_must_be_provided },
  ]

  requirements.forEach(group => {
    inputs.push({ label: group.label, type: "subsection" })
    group.requirements.forEach(requirement => {
      if (selectedTypeNumber[requirement.condition]) {
        if (requirement.type === 'file') {
          var rowinputs = [];
          if (requirement.link && selectedTypeNumber[requirement.link.id] && loggedAccount >= 200) {
            rowinputs.push({ label: requirement.link.label, type: requirement.link.type, value: selectedTypeNumber[requirement.link.id], id: requirement.link.id, name: requirement.link.name })
          }
          if (requirement.possibilities) rowinputs.push({ label: phrasebook.orders.possible_docs, type: "info", value: selectedTypeNumber[requirement.possibilities] });
          rowinputs.push(requirement);
          rowinputs.push({ label: phrasebook.common.uploaded_file, type: "info", value: actualState[requirement.id] });
          inputs.push(rowinputs);

        } else if (requirement.type === 'text') {
          if (loggedAccount < 200) requirement['disabled'] = true;
          inputs.push(requirement);
        } else if (requirement.type === 'download') {
          if (!actualState[requirement.id]) inputs.push({ label: requirement.label, type: "info", value: phrasebook.common.file_not_uploaded })
          else inputs.push(requirement);
        }
      }
    })
  })
  return inputs;
}
